module.exports = __webpack_public_path__ + "img/LogoAWS@512x.c372512c.png";